import PropTypes from 'prop-types'
import SkeletonComponent from '../../../../../components/stories/atoms/skeleton'

const ProjectMenuMobileLoadList = ({ children, isLoading = false }) => {
  const listSize = 10

  const skeletonShape = {
    display: 'flex',
    width: '100%',
    minHeight: '90px',
    height: '100%',
    borderRadius: '16px'
  }

  return (
    <SkeletonComponent
      isLoading={isLoading}
      skeletonShape={skeletonShape}
      elementQuantity={listSize}
    >
      {children}
    </SkeletonComponent>
  )
}

ProjectMenuMobileLoadList.propTypes = {
  children: PropTypes.node,
  isLoading: PropTypes.bool
}

export default ProjectMenuMobileLoadList
